export const SET_TRACKS_LIST = 'tracks/SET_TRACKS_LIST'
export const SET_MANAGE_TRACK = 'tracks/SET_MANAGE_TRACK'
export const UPDATE_ACTIVE_TRACK = 'tracks/UPDATE_ACTIVE_TRACK'
